var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"edit-tags-modal","hide-header":"","hide-footer":""}},[_c('EditTagsForm',{attrs:{"selectedFiles":_vm.selectedFiles},on:{"cancel":_vm.onCancel,"tagging-success":_vm.onTaggingSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }